/** The dashboard's white card surface. */
export const CARD_CLASS_NAME = "rounded-xl border border-cr-slate-15 bg-cr-white shadow-xs"

/** A card or section title. */
export const CARD_TITLE_CLASS_NAME = "text-[15px] font-semibold tracking-[-0.1px] text-cr-slate-90"

/** The dark bubble of the dashboard's tooltips. */
export const TOOLTIP_CLASS_NAME =
  "max-w-xs rounded-[10px] bg-cr-blue-dark pixel-units px-3 py-2 text-[11.5px] leading-normal whitespace-pre-line text-cr-white shadow-lg"

/** A small rounded count or state pill; colours come from the caller. */
export const PILL_CLASS_NAME =
  "inline-flex items-center rounded-full px-[7px] py-0.5 text-[11.5px] font-bold whitespace-nowrap"

/** Colours of a change against the previous period: good, bad or neither. */
export const DELTA_PILL_CLASS_NAME = {
  good: "bg-cr-green-pale text-cr-green-dark",
  bad: "bg-cr-yellow-pale text-cr-yellow-deep",
  neutral: "bg-cr-slate-6 text-cr-slate-60",
} as const
